// extracted by mini-css-extract-plugin
module.exports = {"notification":"_2nRFCit"};